import api from '@/services/utils/apiInstance'

class AuthService {
  async loginValidation(credentials) {
    const response = await api.post('/auth/login', {
      email: credentials.email,
      password: credentials.password
    })

    return response.data
  }

  async loginFinalization(credentials) {
    await api.post('/auth/login/finalize', {
      email: credentials.email,
      password: credentials.password,
      collaborator_id: credentials.collaborator_id
    })
  }

  async verifyLogin2faCode(code) {
    await api.post('/auth/login/2fa/verify', {
      code
    })
  }

  async resendLogin2faCode() {
    await api.post('/auth/login/2fa/resend')
  }

  async me() {
    const response = await api.get('/auth/me')
    return response.data
  }

  async logout() {
    await api.post('/auth/logout')
  }

  async resetPassword(user) {
    const response = await api.post('/reset-password', user)
    return response.data
  }

  async forgotPassword(user) {
    const response = await api.post('/forgot-password', user)
    return response.data
  }

  async initializePassword(user) {
    const response = await api.post('/initialization-password', user)
    return response.data
  }
}

export default new AuthService()
